var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"home-section-header"},[(_vm.eyebrow)?_c('p',{staticClass:"home-section-eyebrow"},[_vm._v(_vm._s(_vm.eyebrow))]):_vm._e(),_c('h2',{staticClass:"home-section-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"home-section-subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }